import { getMediaTypeFromMimeType } from '@atlaskit/media-common/mediaTypeUtils';
export const getMediaTypeFromUploadableFile = file => {
  if (file.content instanceof Blob) {
    const type = file.content.type;
    return getMediaTypeFromMimeType(type);
  } else {
    return 'unknown';
  }
};